import SlideOut from '../modules/slide-out.babel';

document.addEventListener('DOMContentLoaded', () => {
    const inPageCtas = document.querySelectorAll('.site-content .button:not(.js-mews-submit)');
    const newsletterSlideOut = document.querySelector('.slide-out');
    const slideOutObject = new SlideOut(newsletterSlideOut);

    inPageCtas.forEach((cta) => {
        cta.addEventListener('click', (e) => {
            e.preventDefault();
            slideOutObject.open(e.currentTarget);
        });
    });
});
